/**
 * @generated SignedSource<<0d052b81e61af08afb66840a54aacaf8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ArchiveMarketingEmailInput = {
  id: string;
};
export type ArchiveMarketingEmailDialogMutation$variables = {
  input: ArchiveMarketingEmailInput;
};
export type ArchiveMarketingEmailDialogMutation$data = {
  readonly archiveMarketingEmail: {
    readonly archivedAt: any | null | undefined;
    readonly id: string;
  };
};
export type ArchiveMarketingEmailDialogMutation = {
  response: ArchiveMarketingEmailDialogMutation$data;
  variables: ArchiveMarketingEmailDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MarketingEmail",
    "kind": "LinkedField",
    "name": "archiveMarketingEmail",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "archivedAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ArchiveMarketingEmailDialogMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ArchiveMarketingEmailDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e596891c7fcfceb18972e70b2630165e",
    "id": null,
    "metadata": {},
    "name": "ArchiveMarketingEmailDialogMutation",
    "operationKind": "mutation",
    "text": "mutation ArchiveMarketingEmailDialogMutation(\n  $input: ArchiveMarketingEmailInput!\n) {\n  archiveMarketingEmail(input: $input) {\n    id\n    archivedAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "215f7b05ef9f6d75f698fe6618d6fd1d";

export default node;
